/* unplugin-vue-components disabled */import { render } from "./GrasshopperTabs.vue?vue&type=template&id=3cc2b4ec&scoped=true"
import script from "./GrasshopperTabs.vue?vue&type=script&lang=js"
export * from "./GrasshopperTabs.vue?vue&type=script&lang=js"

import "./GrasshopperTabs.vue?vue&type=style&index=0&id=3cc2b4ec&scoped=true&lang=css"
import "./GrasshopperTabs.vue?vue&type=style&index=1&id=3cc2b4ec&lang=css"

import exportComponent from "/home/runner/work/gh-docs-frontend/gh-docs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc2b4ec"]])

export default __exports__